import React from 'react';
class ImageUploader extends React.Component {
    constructor(props) {
        super(props);
        this.handleAddImage = this.handleAddImage.bind(this);
        this.handleUploadImage = this.handleUploadImage.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragEnter = this.handleDragEnter.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.handleCancelUpload = this.handleCancelUpload.bind(this);
        this.state = {
            file: props.fileName,
            dragOver: false,
            errorNoficication: null,
        };
    }

    static getDerivedStateFromProps(nextProps) {
        return {
            file: nextProps.fileName,
        };
    }
    /**
       Drag and Drop Event Handlers
    **/
    handleDragEnter(e) {
        e.preventDefault();
    }
    handleDragOver(e) {
        e.preventDefault();
        if (!this.state.dragOver) {
            this.setState({
                dragOver: true,
            });
        }
    }
    handleDragLeave(e) {
        e.preventDefault();
        this.setState({
            dragOver: false,
        });
    }

    handleDrop(e) {
        e.preventDefault();
        let file = e.dataTransfer.files;
        // console.log("file",file)
        // Validate file is of type Image
        let fileType = file[0].type.split('/')[1];
        if (!['csv', 'CSV'].includes(fileType)) {
            this.setState({
                file: null,
                errorNotification: 'Not an csv File',
                dragOver: false,
            });
            return setTimeout(() => {
                this.setState({
                    errorNotification: null,
                });
            }, 3000);
        }
        // this.refs.image.files = e.dataTransfer.files;
        document.getElementById('upload-image-input').fileList =
            e.dataTransfer.files[0];
        this.setState({
            file,
            dragOver: false,
        });
    }

    /**
       Handle Manually (File Input) Added Files
    **/
    handleAddImage(e) {
        e.preventDefault();
        if (typeof this.props.cancelUpload === 'function') {
            this.props.cancelUpload();
        }
        let file = this.refs.image.files[0];
        // console.log(this.props);
        this.props.onChange(e); //////
        this.setState(
            {
                file,
                dragOver: false,
            },
            () => {
                e.target.value = '';
            },
        );
    }
    /**
       Handle Upload after Upload Button Clicked
    **/
    handleUploadImage(e) {
        e.preventDefault();
        if (this.refs.image.files[0]) {
            // console.log("Uploading Image " + this.refs.image.files[0].name + "");
            /**
               Handle image Upload
            **/
        }
    }

    handleCancelUpload(e) {
        e.preventDefault();
        if (typeof this.props.cancelUpload === 'function') {
            this.props.cancelUpload();
        }
        this.setState({
            file: null,
        });
    }
    render() {
        // Match drag over css to hover css
        let dragOverClass = this.state.dragOver
            ? `display-box drag-over`
            : `display-box`;
        // If file is set, change upload box text to file name
        let uploadText = this.state.file ? (
            <div className="upload-file-name">
                <span className="suceess-icn">
                    {' '}
                    <i className="ic-check"></i>{' '}
                </span>
                <h4>{this.state.file}</h4>
                <i
                    className="ic-clearclose cancel-upload-button btn btn-warning"
                    onClick={this.handleCancelUpload}
                ></i>
                {/* <button className="upload-button btn btn-primary" onClick={this.handleUploadImage} >
                    Browse Another File
                </button> */}
            </div>
        ) : (
            <div className="upload-txt">
                <h4> Drop Files Here to Upload</h4>
                <span>Only .csv files are accepted</span>
                <div className="or-txt"> or </div>
                <button className="btn-primary file-btn">
                    <label className="btn-primary file-btn"> Browse File <input type="file" accept={this.props.accept || 'image/*'} onChange={this.handleAddImage} hidden /> </label>
                </button>
            </div>
        );
        // Show Error message if file type is not an image
        let errorNotification = this.state.errorNotification ? (
            <div className="error-notification">
                <p>{this.state.errorNotification}</p>
            </div>
        ) : null;
        return (
            <div className="image-uploader-wrapper">
                <div className={dragOverClass}>
                    <div className="icon-text-box">
                        <div className="upload-icon">
                            {' '}
                            <i
                                className="ic-file-icon"
                                aria-hidden="true"
                            />{' '}
                        </div>
                        <div className="upload-text">{uploadText}</div>
                        {errorNotification}
                    </div>
                    <div>
                        <input
                            type="file"
                            ref="image"
                            id="upload-image-input"
                            className="upload-image-input"
                            accept={this.props.accept || 'image/*'}
                            // onDrop={this.handleDrop}
                            // onDragEnter={this.handleDragEnter}
                            // onDragOver={this.handleDragOver}
                            // onDragLeave={this.handleDragLeave}
                            onChange={this.handleAddImage}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const CSVImport = ({
    name,
    accept = 'image/*',
    onChooseFile,
    fileName,
    cancelUpload,
}) => {
    const selectedFile = (e) => {
        onChooseFile(e, name);
    };
    return (
        <div style={{ textAlign: 'center' }}>
            <div>
                <ImageUploader
                    accept={accept}
                    onChange={selectedFile}
                    fileName={fileName}
                    cancelUpload={cancelUpload}
                />
            </div>
        </div>
    );
};
export default CSVImport;
